import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import CreateForm from '../../../../../../../components/pages/Register/CreateBanners/components/Step1/Form'
import Calendar from '../../../../../../../components/pages/Register/CreateBanners/components/Step2/Calendar'
import Head from '../../../../../../../components/pages/Register/CreateBanners/components/Head'
import { Icon } from '../../../../../../../components/UI'

import {
  selectRole,
  selectStepCreateBanner,
} from '../../../../../../../routing/fetchingfunction/user/user.reducer'
import { setCreateBannerStep } from '../../../../../../../routing/fetchingfunction/user/user.action'

const ClassBannersAdd = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()

  const isEdit = !!params.id

  const role = useSelector(selectRole)
  const step = useSelector(selectStepCreateBanner)

  const handleCreate = () => {
    navigate(`/${role}/settings/my-banners`)
  }

  const handleBack = () => {
    if (step === 1) {
      return navigate(`/${role}/settings/my-banners`)
    }

    dispatch(setCreateBannerStep(step - 1))
  }

  const content = () => {
    switch (step) {
      case 2:
        return (
          <div className="w-full">
            <Calendar onCreate={handleCreate} isEdit={isEdit} />
          </div>
        )
      default:
        return <CreateForm onCancel={handleBack} />
    }
  }

  return (
    <div
      className={`mx-auto w-full flex flex-col ${step === 2 ? 'max-w-[1200px]' : 'max-w-[800px]'}`}
    >
      <button className="flex items-center mb-[20px]" onClick={handleBack}>
        <Icon name="arrow-left-line" color="#ffffff" className="w-[24px] h-[24px]" />

        <span className="text-white font-medium text-sm ml-[12px]">Back</span>
      </button>

      <div
        className={`${step !== 3 ? 'bg-[#FEEBDD]' : ''} rounded-lg text-[#F67443] ${step === 1 ? 'max-w-[800px] w-full px-[148px] py-16' : 'max-w-[1200px] px-[32px] py-8'} flex flex-col items-center justify-start`}
      >
        {step !== 3 && <Head className="!pt-0" />}
        {content()}
      </div>
    </div>
  )
}

export default ClassBannersAdd
